<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';

    const localize = getLocalization();
</script>

<div class="search-history-container">
    <!-- Search history -->
    <a href="/search-history">
        {localize(/* @kp-localization hledani.ZobrazitHledaneDotazy */ 'hledani.ZobrazitHledaneDotazy')}
    </a>
</div>